// extracted by mini-css-extract-plugin
module.exports = {"content2":"DT_content2__3DALU","dt":"DT_dt__10S1t","dt_font":"DT_dt_font__3DvbD","dt_zh":"DT_dt_zh__386dj","dt_en":"DT_dt_en__3Of2_"};